var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaternityLeaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.512,
    height: 14.424,
    viewBox: "0 0 6.512 14.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8231",
    "data-name": "Path 8231",
    d: "M8.814,3.442A1.538,1.538,0,0,1,10.442,2,1.538,1.538,0,0,1,12.07,3.442a1.538,1.538,0,0,1-1.628,1.442A1.538,1.538,0,0,1,8.814,3.442Zm5.7,6.491A2.386,2.386,0,0,0,12.884,7.77a2.334,2.334,0,0,0-2.572-2.164A2.371,2.371,0,0,0,8,7.885V12.1a.774.774,0,0,0,.814.721h.814v2.524a1.156,1.156,0,0,0,1.221,1.082,1.156,1.156,0,0,0,1.221-1.082V12.818H13.7a.774.774,0,0,0,.814-.721Z",
    transform: "translate(-8 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaternityLeaveIcon);
export default __webpack_public_path__ + "static/media/maternity_leave_icon.4af689dc30dcf85af4626e9f3ffdbe2a.svg";
export { ForwardRef as ReactComponent };